import { Div, router } from '@codesuma/baseline'
import style from './index.module.css'

// A tappable menu row. `action` is either a route path (navigate to it) or a
// callback (e.g. open a mailto link).
export const MenuItem = (title: string, action: string | (() => void)) => {
    const base = Div(title)
    base.addClass(style.base)
    base.el.onclick = typeof action === 'string' ? () => router.goto(action) : action
    return base
}
